import React from 'react'
import { isEmpty } from 'lodash'
import { TFunction } from 'i18next'
import styled from 'styled-components/macro'
import CurrencySymbol from 'components/CurrencySymbol/CurrencySymbol'
import { selectedRateAndBankName } from 'pages/features/CreditInterest/utils/creditInterestTransformers'
import { CreditInterest, Operand, RateTierBand } from 'store/products/types'
import { BankInterestRate, SelectedRateAndBankName } from 'store/referenceData/types'
import { isNullOrUndefined } from 'utils/common.util'
import { fixRateNumber, RateMultiplyByHundred } from 'utils/form.utils'

const StyledSpan = styled.span`
  font-size: 14px;
  color: ${(props: any) => props.theme.palette.text.secondary};
`

const getStaticDefinitions = (
  { spread, operand, interestTierBand, tierBandCalcMethod, bankInterestRateIndex }: CreditInterest,
  currencyOfProduct: string | null,
  bankIndexRates: BankInterestRate[],
  t: TFunction
) => {
  let selectedRateAndBankNameObject: SelectedRateAndBankName | null = null

  if (bankIndexRates && bankInterestRateIndex && bankInterestRateIndex !== '' && !isEmpty(bankIndexRates)) {
    selectedRateAndBankNameObject = selectedRateAndBankName(bankIndexRates, bankInterestRateIndex)
  }

  return [
    !isNullOrUndefined(spread) &&
      tierBandCalcMethod === RateTierBand.FLAT && {
        term: t('Flat'),
        definitions: [
          selectedRateAndBankNameObject !== null &&
          selectedRateAndBankNameObject.bankName &&
          selectedRateAndBankNameObject.rate ? (
            <>
              {`${
                operand === Operand.SUBTRACT
                  ? fixRateNumber(selectedRateAndBankNameObject.rate - RateMultiplyByHundred(spread as number, 4), 4)
                  : fixRateNumber(selectedRateAndBankNameObject.rate + RateMultiplyByHundred(spread as number, 4), 4)
              }% `}
              <StyledSpan>
                {`(${selectedRateAndBankNameObject.bankName}: ${selectedRateAndBankNameObject.rate}% `}
                {spread !== null && spread !== undefined && (
                  <span>
                    {`${operand === Operand.SUBTRACT ? '-' : '+'} ${t('your margin')}: ${RateMultiplyByHundred(
                      spread,
                      4
                    )}%)`}
                  </span>
                )}
              </StyledSpan>
            </>
          ) : null,
        ],
      },
    tierBandCalcMethod &&
      [RateTierBand.BAND, RateTierBand.TIER].includes(tierBandCalcMethod) &&
      !isNullOrUndefined(interestTierBand) &&
      !isEmpty(interestTierBand) && {
        term: tierBandCalcMethod === RateTierBand.TIER ? t('Tiers') : t('Bands'),
        definitions: [
          interestTierBand?.map((item) => (
            <div key={`${item.endRange}-${item.startRange}`}>
              <CurrencySymbol
                typographyProps={{ variant: 'inherit', variantMapping: { subtitle2: 'span' } }}
                currencyCode={currencyOfProduct}
              />
              {new Intl.NumberFormat('en-GB').format(item.startRange || 0)}
              {!isNullOrUndefined(item.endRange) && (
                <>
                  {' – '}
                  <CurrencySymbol
                    typographyProps={{ variant: 'inherit', variantMapping: { subtitle2: 'span' } }}
                    currencyCode={currencyOfProduct}
                  />
                  {new Intl.NumberFormat('en-GB').format(item.endRange || 0)}
                </>
              )}
              {!isNullOrUndefined(item.tierBandSpread) &&
              selectedRateAndBankNameObject !== null &&
              selectedRateAndBankNameObject.bankName &&
              selectedRateAndBankNameObject.rate ? (
                <span>
                  {` = ${
                    item.tierBandOperand === Operand.SUBTRACT
                      ? fixRateNumber(
                          selectedRateAndBankNameObject.rate - RateMultiplyByHundred(item.tierBandSpread || 0, 4),
                          4
                        )
                      : fixRateNumber(
                          selectedRateAndBankNameObject.rate + RateMultiplyByHundred(item.tierBandSpread || 0, 4),
                          4
                        )
                  }% `}
                </span>
              ) : null}
              {selectedRateAndBankNameObject !== null &&
              selectedRateAndBankNameObject.bankName &&
              selectedRateAndBankNameObject.rate &&
              !isNullOrUndefined(item.tierBandSpread) ? (
                <StyledSpan>
                  {`(${selectedRateAndBankNameObject.bankName}: ${selectedRateAndBankNameObject.rate}%`}
                  {` ${item.tierBandOperand === Operand.SUBTRACT ? ' - ' : ' + '}`}
                  {`${t('your margin')}: ${RateMultiplyByHundred(item.tierBandSpread || 0, 4)}%)`}
                </StyledSpan>
              ) : null}
            </div>
          )),
        ],
      },
  ].filter((item) => item)
}
export default getStaticDefinitions
